import { z } from "zod";
/**
 * Installeur premier-lancement (SITE_SPEC — flux « Installeur » façon Azuriom).
 *
 * Le wizard /install configure DB (MySQL/MariaDB) + Redis (avec test de connexion),
 * crée le super-admin du site (PBKDF2, admin même sans compte de jeu lié), finalise et
 * écrit un marqueur d'installation qui VERROUILLE l'installeur.
 *
 * Ces DTOs sont le contrat entre le wizard React et les routes BFF /api/install/*.
 * Toutes les créances restent côté serveur (jamais renvoyées au navigateur après finalize).
 */
/** Configuration base de données (MySQL/MariaDB). */
export const DbConfigSchema = z.object({
    host: z.string().min(1),
    port: z.number().int().min(1).max(65535),
    user: z.string().min(1),
    password: z.string(),
    database: z.string().min(1),
});
/** Configuration Redis (partagée avec le serveur : live/pubsub/cache). */
export const RedisConfigSchema = z.object({
    host: z.string().min(1),
    port: z.number().int().min(1).max(65535),
    password: z.string().optional(),
    db: z.number().int().min(0).max(15).optional(),
});
/**
 * Configuration du pont serveur Minecraft (Etheria_WebAPI).
 * `url` = base loopback (défaut http://127.0.0.1:3015) ; `key` = secret partagé X-Etheria-Api-Key
 * qui DOIT correspondre à `web.api-key` du config.yml côté serveur MC. Peut rester vide/éditée plus tard.
 */
export const WebApiConfigSchema = z.object({
    url: z.string().min(1),
    key: z.string(),
});
/** État d'installation : posé/absent + étape courante du wizard. */
export const INSTALL_STEPS = ["db", "redis", "webapi", "admin", "finalize", "done"];
export const InstallStepSchema = z.enum(INSTALL_STEPS);
/** État d'installation (GET /api/install/status). */
export const InstallStatusSchema = z.object({
    installed: z.boolean(),
    step: InstallStepSchema.optional(),
});
/** Requête de test de connexion DB (POST /api/install/db/test). */
export const InstallDbTestReqSchema = z.object({
    db: DbConfigSchema,
});
/** Requête de test de connexion Redis (POST /api/install/redis/test). */
export const InstallRedisTestReqSchema = z.object({
    redis: RedisConfigSchema,
});
/** Requête de test du pont serveur Minecraft (POST /api/install/webapi/test). */
export const InstallWebApiTestReqSchema = z.object({
    webapi: WebApiConfigSchema,
});
/** Résultat d'un test de connexion (DB, Redis ou WebAPI). */
export const ConnTestResSchema = z.object({
    ok: z.boolean(),
    error: z.string().optional(),
    latencyMs: z.number().nonnegative().optional(),
});
/** Création du super-admin du site (PBKDF2 ; admin sans lien de jeu). */
export const AdminSetupReqSchema = z.object({
    email: z.string().email(),
    username: z.string().min(3).max(32),
    password: z.string().min(8).max(200),
});
/** Finalisation : écrit config + marqueur d'installation (verrou). */
export const InstallFinalizeReqSchema = z.object({
    db: DbConfigSchema,
    redis: RedisConfigSchema,
    webapi: WebApiConfigSchema,
    admin: AdminSetupReqSchema,
});
//# sourceMappingURL=install.js.map